import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const Loader = styled.div`
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: ${rotateAnimation} 2s linear infinite;
`;

const LoaderContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 108vh;
    width: 100vw;
    background: black;
    opacity: 0.5;
    z-index: 1;
`;

const LoaderWrapper = () => {
    return (
        <LoaderContainer>
            <Loader/>
        </LoaderContainer>
    )
}

export default LoaderWrapper;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/LoaderWrapper.jsx